import matches from 'lodash/matches';

const updateWhere = (collection, query, properties) => {
  const matcher = matches(query);
  return collection.map((item) => (matcher(item) ? { ...item, ...properties } : item));
};

export default updateWhere;
